import React from 'react'
import { bangla } from './../../constant/language';

const ReturnPolicy = () => {
  return (
    <div className='mt-0 sm:mt-16 sm:py-8 px-10'>
        {bangla?    <h1 className='text-xl font-bold mb-5'>প্রত্যাবর্তন নীতিমালা</h1>:    <h1 className='text-xl font-bold mb-5'>Return Policy</h1>}
         
        {

         bangla ? <>    <p>  <p className='font-semibold'>  ব্যবহারকারী ডেলিভারির সময়, বা 7 দিনের মধ্যে যেকোনো পণ্য ফেরত দিতে পারেন যদি:</p> 

         <li>পণ্য ব্যবহারকারীর প্রত্যাশা পূরণ করে না। </li>

         <li>প্রসবের সময় ক্ষতিগ্রস্ত পাওয়া গেছে </li>

         <li>পণ্যের গুণমান এবং পরিমাণ সম্পর্কে সন্দেহ আছে </li>

         <li>অস্বাস্থ্যকর/অপ্রত্যাশিত অবস্থায় প্রাপ্ত </li>

         <li>প্যাকেজিং সঙ্গে সন্তুষ্ট না </li>

         <li>পণ্য অব্যবহারযোগ্য খুঁজে পায়</li>
         <br/>

         
পচনশীল পণ্য যেমন দুধ, ফল এবং তাজা সবজির জন্য, আমাদের একটি (1) দিনের রিটার্ন নীতি রয়েছে।
         <br/>আমরা ক্রমাগত রিটার্ন এবং রিফান্ডের জন্য অত্যধিক অনুরোধ সহ গ্রাহকদের অ্যাকাউন্ট পর্যবেক্ষণ করছি। এটি প্রতিরোধে আমরা প্রয়োজনীয় পদক্ষেপ নিচ্ছি।
     </p>
     
     <br/>
     <br/>
     <p>    <p className='font-semibold'>ব্যবহারকারী আইটেম প্রাপ্তির 7 দিনের মধ্যে 10% বা তার কম পর্যন্ত যেকোনও না খোলা বা ত্রুটিপূর্ণ আইটেম ফেরত দিতে পারে। কিন্তু নিম্নলিখিত পণ্যগুলি ফেরত বা প্রতিস্থাপনের জন্য যোগ্য নাও হতে পারে: </p> 

         <li>অকার্যকর পণ্যের কারণে আকস্মিক ক্ষতি</li>

         <li>ব্যবহারযোগ্য/ইন্সটল করা হয়েছে এমন যেকোন ভোগ্য আইটেম </li>

         <li>টেম্পার করা বা অনুপস্থিত সিরিয়াল/ইউপিসি নম্বর সহ পণ্য </li>

         <li>কোনো ক্ষতি/ত্রুটি যা প্রস্তুতকারকের ওয়ারেন্টির আওতায় নেই</li>

         <li>যে কোনও পণ্য যা সমস্ত আসল প্যাকেজিং এবং আনুষাঙ্গিকগুলি ছাড়াই ফেরত দেওয়া হয়, যার মধ্যে বাক্স, প্রস্তুতকারকের প্যাকেজিং যদি থাকে, এবং অন্য সমস্ত আইটেম যা মূলত পণ্য/গুলি বিতরণের সাথে অন্তর্ভুক্ত থাকে।  </li>

         
         <br/>
     </p>
     

     <h1 className='text-xl font-bold mt-10 mb-5'>প্রত্যর্পণ নীতি</h1>
     <p>   <p className='font-semibold'>1. </p>komdaam.com ব্যবহারকারীদের পরিবেশন করার জন্য যথাসাধ্য চেষ্টা করে। কিন্তু যদি কোন পরিস্থিতিতে, আমরা আমাদের প্রতিশ্রুতি পূরণ করতে বা পরিষেবা প্রদান করতে ব্যর্থ হই, আমরা আপনাকে ফোন/টেক্সট/ইমেলের মাধ্যমে 24 ঘন্টার মধ্যে অবহিত করব। Komdaam.com যে পরিষেবাটি সম্পূর্ণ করতে ব্যর্থ হয়, যদি কোনও অর্থ ফেরতের প্রয়োজন হয়, তবে এটি আমাদের স্বীকৃতির 7 দিনের মধ্যে সর্বাধিক করা হয়।<br/>

         <p className='font-semibold'>2. </p>Rউল্লিখিত পরিস্থিতিতে ফেরত অনুরোধ প্রক্রিয়া করা হবে:
         <li>কোন পণ্যের সাথে পরিবেশন করতে অক্ষম। </li>

         <li>পেইড অর্ডার থেকে গ্রাহক যেকোনো পণ্য ফেরত দেন।</li>

         <li>ustomer একটি প্রদত্ত আদেশ প্রেরিত হওয়ার আগে বাতিল করে।</li>
         <br/>
         উপরের তিনটি পরিস্থিতির জন্য, ফেরতের পরিমাণ গ্রাহকের কমদাম ব্যালেন্সে পাঠানো হবে। এবং ব্যালেন্স শুধুমাত্র komdaam.com এ ক্রয় করতে ব্যবহার করা যাবে। গ্রাহকের অনুরোধের ভিত্তিতে, komdaam.com 7 দিনের মধ্যে ব্যবহারকারীর মূল অর্থপ্রদানের উৎসে ফেরতের পরিমাণ হস্তান্তর করবে। রিফান্ড শুধুমাত্র সেই গ্রাহকদের জন্য অনুমোদিত যারা বিকাশ বা কার্ড বা অন্যান্য ইলেকট্রনিক পদ্ধতির মাধ্যমে অর্থ প্রদান করেছেন। নগদ অর্থের মাধ্যমে প্রদান করা অর্ডারগুলির জন্য, শুধুমাত্র কমদাম ক্রেডিটগুলির মাধ্যমে একটি ফেরত দিতে হবে।

     </p> </> : <>
     
     <p>  <p className='font-semibold'>  User may return any product during the time of delivery, or within 7 days if:</p> 

<li>Product does not meet the user’s expectations. </li>

<li>Found damaged during delivery </li>

<li>Have doubt about the product quality and quantity </li>

<li>Received in an unhealthy/ unexpected condition </li>

<li>Is not satisfied with the packaging </li>

<li>Finds product unusable </li>
<br/>

For perishable products such as milk, fruits, and fresh vegetables, we have a one (1) day return policy.
<br/>We are continuously monitoring accounts of customers with excessive requests for returns and refunds. We take the necessary steps to prevent this. 
</p>

<br/>
<br/>
<p>    <p className='font-semibold'>User may return any unopened or defective up to 10% and less, item within 7 days of receiving the item. But following products may not be eligible for return or replacement: </p> 

<li>Damages due to misuse of the product</li>

<li>Incidental damage due to malfunctioning product </li>

<li>Any consumable item which has been used/installed  </li>

<li> Products with tampered or missing serial/UPC numbers </li>

<li>Any damage/defect which is not covered under the manufacturer's warranty </li>

<li>Any product that is returned without all original packaging and accessories, including the box, manufacturer's packaging if any, and all other items originally included with the product/s delivered. </li>
<br/>
</p>


<h1 className='text-xl font-bold mt-10 mb-5'>Refund Policy</h1>
<p>   <p className='font-semibold'>1. </p>komdaam.com tries its best to serve the users. But if under any circumstances, we fail to fulfill our commitment or to provide the service, we will notify you within 24 hours via phone/ text/ email. If the service, that Komdaam.com fails to complete, requires any refund, it is done maximum within 7 Days after our acknowledgment.<br/>

<p className='font-semibold'>2. </p>Refund requests will be processed under mentioned situation:
<li>Unable to serve with any product. </li>

<li>Customer returns any product from a paid order.</li>

<li>ustomer cancels a paid order before it has been dispatched.</li>
<br/>
For all the above three scenarios, the refund amount will be sent to the Komdaam Balance of the
customer. And the balance can only be used to purchase at komdaam.com. Upon the customer's request, komdaam.com will transfer the refund amount to the user's original payment source within 7 days. Refund is only allowed for customers who have paid via bKash or card or other electronic methods. For the orders that are paid via Cash, a refund is only to be given through komdaam Credits.


</p>
     
     
     
     
     
     </>


        }
           
        </div>
  )
}

export default ReturnPolicy